import {spring} from 'react-motion';

export const FADE_IN_UP = {
  enter: {opacity: 1, translateY: spring(0, {stiffness: 300, damping: 20})},
  leave: {opacity: 0, translateY: 100},
};
